module.exports = __webpack_public_path__ + "img/left2.0f8d83d.png";